import sumBy from 'lodash/sumBy';

export default function calculateTotal(prices) {
  return sumBy(prices, price => parseFloat(price, 10));
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/pricing/calculateTotal.js